import type { ReactNode } from "react";

type KbdProps = {
  children: ReactNode;
};

export function Kbd({ children }: KbdProps) {
  return <span className="kbd">{children}</span>;
}
